export default __webpack_public_path__ + "static/media/student_life.56c86c6e.jpg";